import React, { useState } from "react";

import photo2 from "../../../assets/Gallery/photo2.png";
import photo3 from "../../../assets/Gallery/photo3.jpg";
import photo4 from "../../../assets/Gallery/photo4.png";
import photo5 from "../../../assets/Gallery/photo5.png";
import photo6 from "../../../assets/Gallery/photo6.png";
import photo7 from "../../../assets/Gallery/photo7.png";
import photo8 from "../../../assets/Gallery/photo8.png";

const CompanyPhotoStatic = () => {
  return (
    <>
      <div className="company_photos">
        <div className="container">
          <div className="heading_box">Company Photos</div>
          <div className="row">
            <div className="col-lg-6 mb-4">
              <img src={photo7} className="img-fluid" alt="" />
            </div>
            <div className="col-lg-6 mb-4">
              <img src={photo6} className="img-fluid" alt="" />
            </div>

            <div className="col-lg-6 mb-4">
              <img src={photo3} className="img-fluid" alt="" />
            </div>
            <div className="col-lg-6 mb-4">
              <img src={photo2} className="img-fluid" alt="" />
            </div>

            <div className="col-lg-6 mb-4">
              <img src={photo4} className="img-fluid" alt="" />
            </div>
            <div className="col-lg-6 mb-4">
              <img src={photo5} className="img-fluid" alt="" />
            </div>

            <div className="col-lg-6 mb-4">
              <img src={photo3} className="img-fluid" alt="" />
            </div>
            <div className="col-lg-6 mb-4">
              <img src={photo8} className="img-fluid" alt="" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CompanyPhotoStatic;
